import React, { Component } from 'react';
import {Icon, Popover, PopoverInteractionKind, Position, Menu, MenuItem, MenuDivider} from "@blueprintjs/core";
import _ from 'lodash';

class SerieSelector extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isOpen: false
        }
    }

    onOpen = () => {
        this.setState({ isOpen: true })
    };
    onClose = () => {
        this.setState({ isOpen: false })
    };
    render() {
        const popoverContent = (
            <Menu>
                { this.props.series.map(serie => {
                        return (
                            <MenuItem
                                active={this.props.serieSelectedId === serie.get('_id')}
                                text={serie.get('prefix') + _.repeat('%', serie.get('number_length')) }
                                onClick={ () => {
                                    this.props.onChangeSerieSelected(
                                        serie.get('_id'),
                                        serie.get('prefix') + _.padStart((serie.get('last_count') + 1), serie.get('number_length'), '0')
                                    );
                                }}
                                key={serie.get('_id')}
                            />
                        );
                    })
                }
                <MenuDivider/>
                <MenuItem
                    active={this.props.serieSelectedId === 'manual'}
                    text="Serie Manual"
                    onClick={ () => this.props.onChangeSerieSelected('manual', '') }
                />
            </Menu>
        );

        return (
            <Popover
                content={popoverContent}
                interactionKind={PopoverInteractionKind.CLICK}
                position={Position.LEFT_BOTTOM}
                isOpen={this.state.isOpen}
                onClose={this.onClose}
            >
                <Icon
                    className={ `cursor-pointer ch-blue ${this.state.isOpen ? 'c-blue' : ''}` }
                    icon="cog"
                    title="Selector de Serie"
                    style={{margin: '0px 7px'}}
                    iconSize={20}
                    onClick={this.state.isOpen ? this.onClose : this.onOpen}
                />
            </Popover>
        );
    }

}

export default SerieSelector;


// WEBPACK FOOTER //
// ./src/components/common/SerieSelector.js